import React, { useState, useEffect } from 'react';
import './StatsBar.css';

export default function StatsBar({ stats, timeLimit }) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!timeLimit) return;

    const interval = setInterval(() => {
      setElapsed(prev => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLimit]);

  const remaining = timeLimit ? Math.max(0, timeLimit - elapsed) : null;

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  return (
    <div className="stats-bar">
      <div className="stats-bar__item">
        <span className="stats-bar__label">Stars</span>
        <span className="stats-bar__value">{stats.actors}</span>
      </div>
      <span className="stats-bar__divider">|</span>
      <div className="stats-bar__item">
        <span className="stats-bar__label">Titles</span>
        <span className="stats-bar__value">{stats.titles}</span>
      </div>
      {stats.hintsUsed > 0 && (
        <>
          <span className="stats-bar__divider">|</span>
          <div className="stats-bar__item">
            <span className="stats-bar__label">Hints</span>
            <span className="stats-bar__value stats-bar__value--hint">{stats.hintsUsed}</span>
          </div>
        </>
      )}
      {stats.bestPath !== null && (
        <>
          <span className="stats-bar__divider">|</span>
          <div className="stats-bar__item">
            <span className="stats-bar__label">Best</span>
            <span className="stats-bar__value stats-bar__value--gold">{stats.bestPath}</span>
          </div>
        </>
      )}
      {remaining !== null && (
        <div className={`stats-bar__timer ${remaining <= 30 ? 'stats-bar__timer--warning' : ''} ${remaining <= 10 ? 'stats-bar__timer--danger' : ''}`}>
          {formatTime(remaining)}
        </div>
      )}
    </div>
  );
}
